import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
// import { scrollToTop } from '../core/index';
import { getAjaxhelper } from 'src/utils';
export interface BaliDynastyProps extends BaseComponentProps {
    lang: string;
    history?: History | any;
}

export interface BaliDynastyState extends BaseComponentState {
    formSubmit: {
        name: string,
        email: string,
        phone: string,
        country: string,
        subject: string,
        msg: string,
    };
}
/*
const GMimages = {
    "satu" : [
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Premiere-Garden-View-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-23-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-25-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-18-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-15-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-12-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-3-400x314.jpg',

    ]
};
*/

interface BaliDynastyDataSt {
    imageUrl: string;
    roomName: string;
    price: number;
    curencyCode: 'USD' | 'AUD' | 'IDR';
    linkUrl: string;
}

const BaliDynastyData: BaliDynastyDataSt[] = [
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2019/06/Deluxe-King-Size-Bed-400x314.jpg',
        roomName: 'Bali Dynasty Deluxe Room',
        price: 144,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/bali-dynasty-deluxe-room/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2019/06/DSC09970-400x314.jpg',
        roomName: 'Bali Dynasty Deluxe Pool View',
        price: 162,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/bali-dynasty-deluxe-pool-view/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2019/06/Family-Studio-edt-2-400x314.jpg',
        roomName: 'Bali Dynasty Family Studio Room',
        price: 228,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/bali-dynasty-family-studio-room/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2019/06/Deluxe-Family-Package-400x314.jpg',
        roomName: 'Bali Dynasty Deluxe Family Package',
        price: 276,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/bali-dynasty-deluxe-family-package/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2019/06/DSC00040-400x314.jpg',
        roomName: 'Bali Dynasty Kids Suite',
        price: 246,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/bali-dynasty-kids-suite/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2019/06/DSC09987-400x314.jpg',
        roomName: 'Bali Dynasty Executive Suite',
        price: 306,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/bali-dynasty-executive-suite/'
    }
];
export class BaliDynasty extends BaseComponent<BaliDynastyProps, BaliDynastyState> {
    constructor(props: BaliDynastyProps) {
        super(props);
        this.state = {
            formSubmit: {
                name: '',
                email: '',
                phone: '',
                msg: '',
                country: '',
                subject: ''
            }
        };
    }

    componentDidUpdate() {
        // scrollToTop();
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let roomandrate = [];
        for (let rate of BaliDynastyData) {
            roomandrate.push(
                <div className="col-md-4">
                    <div
                        style={{ marginBottom: 30, border: '1px #ddd solid', cursor: "pointer" }}
                        onClick={
                            () => {
                                window.open(`${rate.linkUrl}`, '_blank');
                                // window.location.href = ;
                            }
                        }
                    >
                        <div>
                            <img width="100%" src={`${rate.imageUrl}`} />
                        </div>
                        <div style={{ padding: 15, marginBottom: 35 }}>
                            <h4 style={{ fontWeight: 800, color: '#2eb7fd' }}>{rate.roomName}</h4>
                            <h3 style={{ float: 'right', fontWeight: 800, color: 'rgb(95, 73, 255)' }}>{`${rate.curencyCode} ${rate.price}`}</h3>
                            <p>
                                <a href={`${rate.linkUrl}`} className="btn btn-primary form-control" style={{float: "right"}} target="_blank" >Book Online Now</a>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div style={{ paddingBottom: 20, fontSize: 14, paddingTop: 130 }}>
                <div>
                    <video
                        poster="https://storage.googleapis.com/balivillasandmore/video/Bali-Dynasty-Resort-Video.jpg"
                        loop={true}
                        controls={true}
                        width="100%"
                        height="auto"
                    >
                        <source src="https://storage.googleapis.com/balivillasandmore/video/Bali-Dynasty-Resort-Video.mp4" type="video/mp4" />
                        Your browser doesn’t support HTML5 video. Here is<br /> a <a href="https://storage.googleapis.com/balivillasandmore/video/Bali-Dynasty-Resort-Video.mp4">link to the video</a> instead.
                    </video>
                </div>

                <div style={{ padding: '20px', background: `url("https://storage.googleapis.com/bali-hotel-images/grand-mirage-spacer-1.jpg")`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                    <h2 style={{ textAlign: 'center', fontWeight: 800 }}>Bali Dynasty Resort - Special Offers</h2>
                    
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>About Bali Dynasty Resort</h3>

                        <p>Bali Dynasty Resort Hotel is a premier beachside resort in South Kuta Bali, renowned for its warm Balinese hospitality.</p>
                        <p>Bali Dynasty Resort Hotel Bali is fully integrated and offers:</p>
                        <ul>
                            <li>Six restaurants</li>
                            <li>Five bars</li>
                            <li>Three swimming pools including a kids pool with its own Kids Water Fun Zone and a dedicated adults only pool</li>
                            <li>Spa, Beach Club, Kids’ Club, Kids’ Playground, Teens Club</li>
                            <li>Meeting and wedding facilities</li>
                            <li>Free Wi-Fi throughout the resort</li>
                        </ul>
                        <p>The unique layout allows for a subtle but effective division between the couple and family market.</p>

                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://storage.googleapis.com/bali-hotel-images/about-bali-dynasty-resort.jpg" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 " style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Special Offers</h3>
                        <p>Additional Benefits Min 7 Nights Stay</p>
                        <ul>
                            <li>Free one time themed buffet dinner in H2O Restaurant based on room occupants.</li>
                            <li>Free one time 15 mins spa sampler for 2 people</li>
                            <li>Free one time limited laundry in one delivery</li>
                            <li>Buy one love bucket cocktail and get the second one for free at the Upper Deck at H2O</li>
                            <li>Buy one cocktail and get the second one for free at D’ Lounge Bar</li>
                            <li>Ask Us About The Entire Range Of Special Discounts</li>
                        </ul>
                        <a href="#frmSumbit" style={{ float: "right" }} className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6 ">
                        <img src="https://storage.googleapis.com/bali-hotel-images/hot-deal-bali-dynasty-resort.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Families</h3>
                        <ul>
                            <li>Kids enjoy a 56-metre waterslide flowing into their own pool and complimentary entrance to the Enchanted Garden Kids’ Club.</li>
                            <li>Free entrance to ‘The Den’ Teens Club for the ages 10-16 years old</li>
                            <li>Kids’ Playground</li>
                            <li>A wide variety of rooms catering to the family market are available, sleeping up to five people</li>
                            <li>Kids 12 years and under eat free when dining with same number of full paying adults at H2O Restaurant Daily Theme Buffet Dinner</li>
                            <li>A daily full activity programme for kids, teens and adults from 9am to 6pm</li>
                            <li>Baby Sitting Service</li>
                        </ul>
                        <p>Enjoy free activities every day for kids and adults during your stay such as Kids Yoga, Duck Feeding, Art Workshop, Indonesian lesson, Cooking Demo, Water Volleyball, Treasure Hunt, Bingo, Frog Race and many more!</p>

                        <a href="#frmSumbit" className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://storage.googleapis.com/bali-hotel-images/family-bali-dynasty-resort.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 " style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Restaurants & Bars</h3>
                        <p>Being a complete resort, the Bali Dynasty boasts a choice of 6 restaurants to enjoy. Each has its own individual theme and caters for different budgets from fine dining to casual dining with a variety of entertainment options</p>
                        <p>Choose from Chinese, Irish, Italian, Western and Asian, Indian, al fresco beside the pool or in air-conditioned comfort.</p>
                        <p>There’s so much variety and the meals are such good value that you won’t ever feel a need to leave the resort!</p>
                        <p>We are able to cater for special dietary requirements, including gluten-free, so please let us know in advance!</p>
                        <a href="#frmSumbit" style={{ float: "right" }} className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6 ">
                        <img src="https://storage.googleapis.com/bali-hotel-images/bars-and-restaurants-bali-dynasty-resort.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30, marginBottom: 20 }}>
                        <h3>Kids Club</h3>
                        <p>
                            The Kupu-Kupu Kiddies' Club is renowned as one of Bali's best Kids' Club facilities. The Kids' Club area is divided into two sections with the ground floor consisting of the 'Enchanted Garden' theme air-conditioned kids' club catering for ages 4-12 years, whilst the first floor is The Den Teens Clubcatering for those aged between 10 and 16. Both facilities are provided free of charge.The Den features Internet, Wii, Play station, X-Box, Movies, Pool, Table Tennis, Table Soccer. A great place to meet new friends and is monitored by our friendly staff.<br />
                            Adjacent to the kids club is the Kids Water Fun Zone with its' giant tipping bucket, two mini waterslides, pull ropes, water curtain, tipping cone, bubbler jets, hose jets, water cannons and tipping troughs enabling the kids to have hours of fun. To the north of the Kids Pool is the baby pool with its mushroom water fountain and beyond that is the new kids play area with swings, climbing frame, seesaw, slides and table tennis.

                        </p>
                        <a href="#frmSumbit" className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://storage.googleapis.com/bali-hotel-images/families-bali-dynasty-resort.gif" width='100%' />
                    </div>
                </div>

                <div id='frmSumbit' style={{ padding: '20px', background: `url("https://storage.googleapis.com/bali-hotel-images/bali-dynasty-special-offer.jpg")`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                    <div className='container'>
                        <div className="col-md-6 " style={{ marginTop: 30 }}>
                            <div>
                                <form id="contactForm" onSubmit={this.formSubmit} style={{ maxWidth: 600, margin: 'auto', padding: 20, background: '#ffffffa8' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h3 style={{ color: 'rgb(43, 40, 74)', fontWeight: 800 }}>Send Us An Enquiry</h3>
                                            <p style={{ color: 'rgb(43, 40, 74)' }}>Fields marked with an <span className="symbol required" /> are required</p>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Your name <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.name}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.name = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }

                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Email address <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="email"
                                                    className="form-control"
                                                    value={this.state.formSubmit.email}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.email = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Phone / Whatsapp </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    data-msg-required="Please enter phone number."
                                                    className="form-control"
                                                    value={this.state.formSubmit.phone}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.phone = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Country <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.country}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.country = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-12">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Subject <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.subject}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.subject = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-12">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Message <span className="symbol required" /> </label>
                                                <textarea
                                                    required={true}
                                                    data-msg-required="Please enter your message."
                                                    className="form-control"
                                                    rows={5}
                                                    value={this.state.formSubmit.msg}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.msg = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button data-caption-delay="900" type="submit" data-caption-class="fadeIn" className="btn btn-primary margin-top-15 opacity-0 btn-wide btn-scroll btn-scroll-top fa-arrow-right animated fadeIn" >
                                                <span>Enquire Now</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ marginTop: 30 }}>
                    <h3 style={{ textAlign: 'center' }}>Rooms & Suites</h3>
                    {roomandrate}
                </div>
            </div>

        );

    }

    formSubmit = (event: any) => {
        event.preventDefault();
        let nameSender = this.state.formSubmit.name;
        let contentClient = "";
        contentClient = "<h3>Thank you for booking your Bali hotel with Bali Hotels and More!</h3>";
        contentClient += `<p>You&rsquo;ve made a great choice; we&rsquo;re with you every step of the way to ensure hassle free holiday planning and that you have a great time in Bali. You&rsquo;ve chosen the Book Now and Pay Later option - this is a great way of making your holiday more affordable. You&rsquo;ll avoid the hidden costs of banking fees and poor currency exchange rates which you can add 5 - 10% to the cost of your accommodation when you pay with your card at the hotel. The Book Now and Pay Monthly option which you&rsquo;ve chosen includes a $1 deposit and then final payment is due 2 weeks prior to arrival in Bali or before the cancellation date of the hotel you have chosen Full terms and conditions are here &nbsp;<a href="https://www.balihotelsandmore.com.au/terms-of-use" target="_blank">https://www.balihotelsandmore.com.au/terms-of-use</a></p>`;
        contentClient += "<p>Our team will now check to ensure we have the option available for the room you want. We will then give you a quick call to confirm your exact requirements. Then we send an invoice for $1 deposit. Once you pay then we then issue and email your hotel vouchers.</p>";
        contentClient += "<p>We would also like to take this opportunity to thank you on behalf of our Bali charities we support including:</p>";
        contentClient += `<p>Soleman Bali - &nbsp;<a href="https://www.solemen.org/">https://www.solemen.org</a> &nbsp;</p>`;
        contentClient += `<p>Stella&rsquo;s Child - <a href="https://www.stellaschild.org/">https://www.stellaschild.org/</a></p>`;
        contentClient += "<p>Your booking really does make a difference here in Bali!</p>";
        contentClient += "<p>We look forward to speaking to you within the next 24 - 48 hours.</p>";
        let contentAdmin = "";
        contentAdmin += `Name : ${this.state.formSubmit.name} <br>`;
        contentAdmin += `email : ${this.state.formSubmit.email} <br>`;
        contentAdmin += `country : ${this.state.formSubmit.country} <br>`;
        contentAdmin += `phoneNumber : ${this.state.formSubmit.phone} <br>`;
        contentAdmin += `Subject : ${this.state.formSubmit.subject} <br><br><br>`;
        contentAdmin += `message : ${this.state.formSubmit.msg} <br><br><br>`;
        contentAdmin += `URL : https://balihotelsandmore.com.au/bali-dynasty-resort-hotels<br><br>`;
        let subject = "[Bali Hotels and More] Bali Dynasty Resort " + `${this.state.formSubmit.subject}`;
        let emailSender = this.state.formSubmit.email;

        let dataSendEmail = {
            nameSender: nameSender,
            contentClient: (contentClient),
            contentAdmin: (contentAdmin),
            emailSender: emailSender,
            subject: subject
        };
        getAjaxhelper().post("/dynamics/email-sender-bham/enquery", dataSendEmail).then(
            x => {
                this.props.history.push('/settlement-thankyou');
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/BaliDynasty.tsx